module.exports = __webpack_public_path__ + "images/bf5_rgba(0,0,0,0.7).jpg?v=49a6b90de1c30b7e4e76eb3f98ae4e45";